import { useField, useFormikContext } from "formik";
import * as React from "react";

import {
  DateTimePicker,
  DateTimePickerProps,
} from "~/src/components/common/datepicker/DateTimePicker";

type Props = {
  name: string;
  disabled?: boolean;
  placeholder?: string;
};

export const FormikDateTimeField: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ name, disabled, placeholder }) => {
  const [{ value }, { error, touched }, { setValue, setTouched }] =
    useField<Date | null>(name);
  const { setFieldTouched } = useFormikContext();

  const handleChange = React.useCallback<DateTimePickerProps["onChange"]>(
    (nextValue) => {
      setValue(nextValue);
      setTouched(true, false);
      // Cross-field: endsAt validates against startsAt — surface that error when start moves.
      if (name === "startsAt") {
        void setFieldTouched("endsAt", true, true);
      }
    },
    [name, setFieldTouched, setTouched, setValue]
  );

  return (
    <DateTimePicker
      value={value}
      onChange={handleChange}
      error={touched ? error : undefined}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
